import { useState } from "react"
import RequestDetailsModal from "./requestDetailsModal";
import AdminToast from "../../../core/admin/adminToast";
import AdminButton from "../../../core/admin/adminButton";
import AdminBadge from "../../../core/admin/adminBadge";
import AdminEmptyState from "../../../core/admin/adminEmptyState";
import { AdminLoading } from "../../../core/admin/adminSpinner";
import { CheckCircleIcon } from "../../../../img/svg/adminIcons";
import { parseTimestamp } from "../../../../utils/functions";

export interface IRequest {
    id: string;
    advertiser: string;
    review: string;
    reason: string;
    createdAt: Date;
    solved: boolean;
}

export default function Requests({ requests, loading, feedback, refresh }: { requests: IRequest[] | null, loading: boolean, feedback: string, refresh: () => Promise<null> }) {

    
    
    const [modal, setModal] = useState(false);
    const [editableRequest, setEditableRequest] = useState<IRequest | null>(null);
    const [goodToast, setGoodToast] = useState(false);
    const [badToast, setBadToast] = useState(false);

    

    const handleEditModal = (request: IRequest) => {
        setEditableRequest(request);
        setModal(true);
    }

    const openRequests = requests?.filter(req => !req.solved) || [];

    return (
        <div>
            {
                loading ?
                    <AdminLoading />
                    : feedback ?
                        <AdminEmptyState title={feedback} />
                        : openRequests.length ?
                            <ul className="flex flex-col gap-3">
                                {
                                    openRequests.map((r, i) => (
                                        <li key={i} className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-red-200 bg-red-50/40 p-4">
                                            <div className="min-w-0 flex-1">
                                                <div className="flex flex-wrap items-center gap-2 mb-1">
                                                    <AdminBadge tone="danger" dot>Exclusão solicitada</AdminBadge>
                                                    <span className="text-xs text-gray-500">{parseTimestamp(r.createdAt)}</span>
                                                </div>
                                                <p className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mt-2">Motivo</p>
                                                <p className="text-sm text-gray-800 break-words">{r.reason || "—"}</p>
                                            </div>
                                            <AdminButton size="sm" variant="secondary" onClick={() => handleEditModal(r)}>Detalhes</AdminButton>
                                        </li>
                                    ))
                                }
                            </ul>
                            : <AdminEmptyState icon={<CheckCircleIcon />} title="Nenhuma solicitação aberta" description="Os pedidos de exclusão enviados pelos anunciantes aparecem aqui." />
            }
            {
                modal && editableRequest ?
                <RequestDetailsModal close={() => setModal(false)} badToast={() => setBadToast(true)} goodToast={() => setGoodToast(true)} refresh={refresh} request={editableRequest}/>
                : null
            }
            <AdminToast toast={goodToast} setToast={setGoodToast} message="Solicitação atualizada!" tone="success" />
            <AdminToast toast={badToast} setToast={setBadToast} message="Erro!" tone="danger" />
        </div>
    )
}
